import { dateToday, dateTwoYearsAgo } from "../../../util/billingUtils";
import * as Actions from "../../actions/billing/invoiceHistoryActions";
const initialState = {
  invoiceList: [],
  actualInvoicelist: [],
  totalNumberOfRecords: 0,
  // activePage: 1,
  activePage: 0,
  showModal: false,
  recordsPerPage: 20,
  pageCount: "",
  goto: "",
  slicedData: [],
  filteredData: [],
  tableData: [],
  actionName: "onLoad",
  fullSearchData: [],
  dateFrom: dateTwoYearsAgo(),
  dateTo: dateToday(),
  sortStatusInvoiceNo: "noSort",
  sortStatusInvoiceDate: "descending",
  sortStatusContract: "noSort",
  sortStatusLocation: "noSort",
  sortStatusAmount: "noSort",
  sortStatusDueAmount: "noSort",
  sortStatusPayStatus: "noSort",
  sortStatusDueDate: "noSort",
  searchOrRefresh: true,
  visibleMakePayment: false,
  visibleManagePayment: false,
  visibleManagePaperlessBilling: false,
  visibleRecurringPayment: false,
  token: "",
  sessionId: "",
  vepsURL: "https://verizonpayment-sit1.verizon.com/sspPortal/?demo=",
  loader: false,
  viewInvoiceError: { isError: false, errorText: "", invoiceNumber: "" },
  downloadInvoiceError: { isError: false, errorText: "", invoiceNumber: "" },
};

const actionHandlers = {
  [Actions.SET_INVOICE_LIST]: (state, action) => ({ ...state, invoiceList: action.value }),
  [Actions.SET_ACTUAL_INVOICELIST]: (state, action) => ({ ...state, actualInvoicelist: action.value }),
  [Actions.SET_TOTAL_NUMBER_OF_RECORDS]: (state, action) => ({ ...state, totalNumberOfRecords: action.value }),
  [Actions.SET_ACTIVE_PAGE]: (state, action) => ({ ...state, activePage: action.value }),
  [Actions.SET_SHOW_MODAL]: (state, action) => ({ ...state, showModal: action.value }),
  [Actions.SET_RECORDS_PERPAGE]: (state, action) => ({ ...state, recordsPerPage: action.value }),
  [Actions.SET_PAGE_COUNT]: (state, action) => ({ ...state, pageCount: action.value }),
  [Actions.SET_GOTO]: (state, action) => ({ ...state, goto: action.value }),
  [Actions.SET_SLICED_DATA]: (state, action) => ({ ...state, slicedData: action.value }),
  [Actions.SET_FILTERED_DATA]: (state, action) => ({ ...state, filteredData: action.value }),
  [Actions.SET_TABLE_DATA]: (state, action) => ({ ...state, tableData: action.value }),
  [Actions.SET_ACTION_NAME]: (state, action) => ({ ...state, actionName: action.value }),
  [Actions.SET_FULL_SEARCH_DATA]: (state, action) => ({ ...state, fullSearchData: action.value }),
  [Actions.SET_DATE_FROM]: (state, action) => ({ ...state, dateFrom: action.value }),
  [Actions.SET_DATE_TO]: (state, action) => ({ ...state, dateTo: action.value }),
  [Actions.SET_SORT_STATUS_INVOICE_NO]: (state, action) => ({ ...state, sortStatusInvoiceNo: action.value }),
  [Actions.SET_SORT_STATUS_INVOICE_DATE]: (state, action) => ({ ...state, sortStatusInvoiceDate: action.value }),
  [Actions.SET_SORT_STATUS_CONTRACT]: (state, action) => ({ ...state, sortStatusContract: action.value }),
  [Actions.SET_SORT_STATUS_LOCATION]: (state, action) => ({ ...state, sortStatusLocation: action.value }),
  [Actions.SET_SORT_STATUS_AMOUNT]: (state, action) => ({ ...state, sortStatusAmount: action.value }),
  [Actions.SET_SORT_STATUS_DUE_AMOUNT]: (state, action) => ({ ...state, sortStatusDueAmount: action.value }),
  [Actions.SET_SORT_STATUS_PAY_STATUS]: (state, action) => ({ ...state, sortStatusPayStatus: action.value }),
  [Actions.SET_SORT_STATUS_DUE_DATE]: (state, action) => ({ ...state, sortStatusDueDate: action.value }),
  [Actions.SET_SEARCH_OR_REFRESH]: (state, action) => ({ ...state, searchOrRefresh: action.value }),
  [Actions.SET_VISIBLE_MAKE_PAYMENT]: (state, action) => ({ ...state, visibleMakePayment: action.value }),
  [Actions.SET_VISIBLE_MANAGE_PAYMENT]: (state, action) => ({ ...state, visibleManagePayment: action.value }),
  [Actions.SET_VISIBLE_MANAGE_PAPERLESS_BILLING]: (state, action) => ({ ...state, visibleManagePaperlessBilling: action.value }),
  [Actions.SET_VISIBLE_RECURRING_PAYMENT]: (state, action) => ({ ...state, visibleRecurringPayment: action.value }),
  [Actions.SET_TOKEN]: (state, action) => ({ ...state, token: action.value }),
  [Actions.SET_SESSION_ID]: (state, action) => ({ ...state, sessionId: action.value }),
  [Actions.SET_VEPS_URL]: (state, action) => ({ ...state, vepsURL: action.value }),
  [Actions.SET_ALERT_MODAL]: (state, action) => ({ ...state, alertModal: action.value }),
  [Actions.SET_LOADER]: (state, action) => ({ ...state, loader: action.value }),
  [Actions.SET_VIEW_INVOICE_ERROR]: (state, action) => ({ ...state, viewInvoiceError: action.value }),
  [Actions.SET_DOWNLOAD_INVOICE_ERROR]: (state, action) => ({ ...state, downloadInvoiceError: action.value }),
  [Actions.RESET]: () => initialState,
};

export const invoiceHistoryReducer = (state = initialState, action) => {
  const handler = actionHandlers[action.type];
  return handler ? handler(state, action) : state;
};
